import api from './api.js';

/**
 * SeasonService provides season-related API calls.
 */
const SeasonService = {
  /**
   * Fetch current season information for a league.
   * Backend route: GET /seasons/leagues/:leagueId/season
   * @param {string} leagueId - MongoDB ID of the league
   * @returns {Promise<Object>} { season: number, ... }
   */
  async getCurrentSeason(leagueId) {
    if (!leagueId) throw new Error('leagueId is required');
    return api.get(`/seasons/leagues/${leagueId}/season`);
  }
};

export default SeasonService;
